import React, { useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";
import auth from "../../services/authService";
import { isLocallyLocked, isSessionLockEnabled } from "../../services/sessionLockService";

const ProtectedRoute = ({ path, component: Component, render, ...rest }) => {
  const [authState, setAuthState] = useState(() =>
    auth.getCurrentUser() ? "authenticated" : "checking"
  );

  useEffect(() => {
    if (authState !== "checking") return;

    // Sync check failed (tokens expired) — try refreshing via refresh token
    fetchAuthSession()
      .then((session) => {
        const accessExp = session?.tokens?.accessToken?.payload?.exp;
        const idExp = session?.tokens?.idToken?.payload?.exp;
        const now = Date.now() / 1000;

        if (accessExp && idExp && accessExp > now && idExp > now) {
          setAuthState("authenticated");
        } else {
          setAuthState("unauthenticated");
        }
      })
      .catch(() => {
        setAuthState("unauthenticated");
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (authState === "checking") return null;

        if (authState === "unauthenticated") {
          if (process.env.NODE_ENV === "production") {
            window.location = "/logout";
            return null;
          }
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location },
              }}
            />
          );
        }

        if (isSessionLockEnabled() && isLocallyLocked()) {
          return null;
        }

        return Component ? <Component {...props} /> : render(props);
      }}
    />
  );
};

export default ProtectedRoute;
